module.exports = __webpack_public_path__ + "img/code-reviewer.187216db.jpeg";